import {Injectable} from '@angular/core';
import {Http, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {Card, CardPagination} from '../entity/card';
import {get} from 'lodash';

@Injectable()
export class CardsService {

    constructor(private _http: Http) {
    }

    getNewCards(page: number, limit: number): Observable<CardPagination> {
        let search: URLSearchParams = new URLSearchParams();
        search.set('page', String(page));
        search.set('limit', String(limit));

        return this._http.get('/api/backoffice/cards/new', {search: search})
            .map(response => response.json())
            .map(response => ({
                page: get(response, 'meta.page', 0),
                records: get(response, 'meta.records', 0),
                total_records: get(response, 'meta.total_records', 0),
                cards: get(response, 'cards', [])
                    .map(card => ({
                        id: card.id,
                        number: card.number,
                        program: card.program,
                        currency: card.currency,
                        short_number: card.short_number,
                        validity: card.validity
                    }))
            }));
    }

    getCardsForProfile(profileId: number): Observable<Card[]> {
        return this._http.get(`/api/backoffice/cards/active-for-profile/${profileId}`).map(response => response.json());
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/service/cards.service.ts